module.exports = __webpack_public_path__ + "2e176373c487745ca9f47753ad4a3331.png";